import { render, staticRenderFns } from "./insuranceTypes.vue?vue&type=template&id=42a6d50b&"
import script from "./insuranceTypes.vue?vue&type=script&lang=js&"
export * from "./insuranceTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports